import { useCallback, useEffect, useState } from 'react';
import { REFERRAL_CODE_KEY } from '../constants/referral.const';

export const useReferralCode = () => {
  const [refCode, setRefCode] = useState<string | null>(null);

  // Get referral code from localStorage on mount
  useEffect(() => {
    const storedCode = localStorage.getItem(REFERRAL_CODE_KEY);
    if (storedCode) {
      setRefCode(storedCode);
    }
  }, []);

  // Set referral code
  const setReferralCode = useCallback((code: string) => {
    try {
      localStorage.setItem(REFERRAL_CODE_KEY, code);
      setRefCode(code);
    } catch (error) {
      console.error('Failed to store referral code:', error);
    }
  }, []);

  // Clear referral code
  const clearReferralCode = useCallback(() => {
    try {
      localStorage.removeItem(REFERRAL_CODE_KEY);
      setRefCode(null);
    } catch (error) {
      console.error('Failed to clear referral code:', error);
    }
  }, []);

  // Extract code from URL params
  const extractCodeFromUrl = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    const codeFromUrl = params.get('code');
    console.log('-- setting ref code ', codeFromUrl);

    if (codeFromUrl) {
      setReferralCode(codeFromUrl);

      // Clean URL
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.delete('code');
      window.history.replaceState({}, '', urlObj.toString());

      return codeFromUrl;
    }

    return null;
  }, [setReferralCode]);

  return {
    refCode,
    setReferralCode,
    clearReferralCode,
    extractCodeFromUrl
  };
};
